import { BaseTable, CommandButton, JournalTable, Modal, TableHeader, 
     JournalLinkedAccount } from "components"
import { Fragment } from "react"
import { convertNumber, useToggle } from "utils"
import type { DataType } from "../types";
import moment from "moment"
import type { FormType } from "../utils"
import { useFormContext, useWatch } from "react-hook-form"

export function Journal(params: { data: DataType }) {
    const { isActive, toggle } = useToggle(false)
    const { control,watch } = useFormContext<FormType>()
    const details = useWatch({ control }) as Partial<FormType>    
    const trx_code = watch('trx_received_code')
    console.log(trx_code);
    

    return (
        <Fragment>
            <CommandButton actiontype="journal" onClick={toggle} />

            {isActive && (
                <Modal isOpen title="JOURNAL" closeModal={toggle} size="full">
                    <Modal.Body>
                        <JournalTableSection data={details} trx_code={trx_code??""}/>
                    </Modal.Body>
                </Modal>
            )}
        </Fragment>
    )
}

function JournalTableSection(params: { data: Partial<FormType>; trx_code:string }) {
    const transaction_date = params.data.transaction_date
    const trx_code = params.trx_code
    const detailTransaction = params.data.received_reject_detail ?? []

    return (
        <JournalTable>
            <JournalTable.Content>
                <BaseTable>
                    <TableHeader>
                        <tr>
                            <th className="w-[10px]">DATE</th>
                            <th>IDM</th>
                            <th>ACCOUNT</th>
                            <th>DEBET</th>
                            <th>CREDIT</th>
                        </tr>
                    </TableHeader>
                    <tbody>
                        {detailTransaction.map((item, index) => {
                            const amount = Math.round(item.qty_received_item * item.price_received * (100 - item.discount) / 100)
                            const amountTax = Math.round(amount * item.tax_rate / 100)

                            return (
                                <Fragment key={index}>
                                    {Boolean(amount) && (
                                        <>
                                            <tr>
                                                <td>{moment(transaction_date).format("DD/MM/YYYY")}</td>
                                                <td>{trx_code}</td>
                                                <JournalLinkedAccount coa_code="LA07"/>
                                                <td className="text-right">{convertNumber(amount).intoCurrency}</td>
                                                <td></td>
                                            </tr>
                                            {Boolean(item.tax_id && item.tax_rate > 0) && (
                                                <tr>
                                                    <td>{moment(transaction_date).format("DD/MM/YYYY")}</td>
                                                    <td>{trx_code}</td>
                                                    <JournalLinkedAccount coa_code="LA07"/>
                                                    <td className="text-right">{convertNumber(amountTax).intoCurrency}</td>
                                                    <td></td>
                                                </tr>
                                            )}
                                            <tr>
                                                <td>{moment(transaction_date).format("DD/MM/YYYY")}</td>
                                                <td>{trx_code}</td>
                                                <JournalLinkedAccount coa_code="LA11" />
                                                <td></td>
                                                <td className="text-right">{convertNumber(amount).intoCurrency}</td>
                                            </tr>
                                            {Boolean(item.tax_id && item.tax_rate > 0) && (
                                               <tr>
                                                    <td>{moment(transaction_date).format("DD/MM/YYYY")}</td>
                                                    <td>{trx_code}</td>
                                                    <JournalLinkedAccount coa_code="LA11"/>
                                                    <td></td>
                                                    <td className="text-right">{convertNumber(amountTax).intoCurrency}</td>
                                                </tr>
                                            )}
                                            
                                           
                                            
                                        </>
                                    )}
                                </Fragment>
                            )
                        })}
                    </tbody>
                </BaseTable>
            </JournalTable.Content>
        </JournalTable>
    )
}
